// Rules used to validate data in input forms

const required = value => !!value || 'This field is required.'

const max20 = value => (value && value.length <= 20) || 'Max 20 characters.'

const min10 = value => (value && value.length >= 10) || 'Min 10 characters.'

const min6 = value => (value && value.length >= 6) || 'Min 6 characters.'

const email = value => {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return pattern.test(value) || 'Invalid e-mail.'
}

const unicode = value => {
  return /^[a-zA-Z0-9 _-]*$/.test(value) || 'Only unicode letters, numbers, underscores, or hyphens.'
}

export default {
  required,
  max20,
  min10,
  min6,
  email,
  unicode
}
